import { render, staticRenderFns } from "./SingleWheelOfFortune.vue?vue&type=template&id=615ff071&scoped=true&"
import script from "./SingleWheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./SingleWheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./SingleWheelOfFortune.vue?vue&type=style&index=0&id=615ff071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ff071",
  null
  
)

export default component.exports